export function EvidenceChip({ status = "DOCUMENTED", className = "" }) {
  const styles = {
    DOCUMENTED: "bg-ptf-accent/25 text-ptf-primary border-ptf-primary/20",
    HISTORICAL: "bg-ptf-primary/8 text-ptf-text/60 border-ptf-primary/15",
    "HISTORICAL TARGET": "bg-ptf-primary/8 text-ptf-text/60 border-ptf-primary/15",
    PILOT: "bg-ptf-secondary/12 text-ptf-secondary border-ptf-secondary/25",
    PLANNED: "bg-transparent text-ptf-text/55 border-ptf-primary/20",
    VERIFY: "bg-[#B4552D]/10 text-[#9A4423] border-[#B4552D]/30",
  };
  return (
    <span data-testid={`evidence-${status.toLowerCase().replace(/\s/g, "-")}`} className={`inline-flex items-center text-[0.58rem] uppercase tracking-[0.14em] border px-2.5 py-1 ${styles[status] || styles.DOCUMENTED} ${className}`}>
      {status}
    </span>
  );
}

export function VerifyFlag({ children = "Content requires verification. This detail is being re-confirmed against source records before publication." }) {
  return (
    <div data-testid="verify-flag" className="border border-[#B4552D]/30 bg-[#B4552D]/[0.05] px-4 py-3 text-xs text-[#9A4423] leading-relaxed">
      <span className="font-semibold uppercase tracking-[0.12em] mr-2">Requires verification</span>
      {children}
    </div>
  );
}
